var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeerToPeer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,12.25H13A1.76,1.76,0,0,0,11.25,14v4A1.76,1.76,0,0,0,13,19.75h2.75v.5H15a.75.75,0,0,0,0,1.5h3a.75.75,0,0,0,0-1.5h-.75v-.5H20A1.76,1.76,0,0,0,21.75,18V14A1.76,1.76,0,0,0,20,12.25ZM20.25,18a.25.25,0,0,1-.25.25H13a.25.25,0,0,1-.25-.25V14a.25.25,0,0,1,.25-.25h7a.25.25,0,0,1,.25.25ZM11,9.75A1.76,1.76,0,0,0,12.75,8V4A1.76,1.76,0,0,0,11,2.25H4A1.76,1.76,0,0,0,2.25,4V8A1.76,1.76,0,0,0,4,9.75H6.75v.5H6a.75.75,0,0,0,0,1.5H9a.75.75,0,0,0,0-1.5H8.25v-.5ZM3.75,8V4A.25.25,0,0,1,4,3.75h7a.25.25,0,0,1,.25.25V8a.25.25,0,0,1-.25.25H4A.25.25,0,0,1,3.75,8ZM9.53,18.47a.75.75,0,0,1,0,1.06l-2,2a.75.75,0,0,1-1.06,0,.75.75,0,0,1,0-1.06l.72-.72H4A1.76,1.76,0,0,1,2.25,18V14a.75.75,0,0,1,1.5,0v4a.25.25,0,0,0,.25.25H7.19l-.72-.72a.75.75,0,0,1,1.06-1.06ZM21.75,6v4a.75.75,0,0,1-1.5,0V6A.25.25,0,0,0,20,5.75H16.81l.72.72a.75.75,0,0,1,0,1.06.75.75,0,0,1-1.06,0l-2-2a.75.75,0,0,1,0-1.06l2-2a.75.75,0,0,1,1.06,1.06l-.72.72H20A1.76,1.76,0,0,1,21.75,6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeerToPeer);
export default __webpack_public_path__ + "static/media/peer-to-peer.c856a0e704961dfa434ad42977819a40.svg";
export { ForwardRef as ReactComponent };